import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import {
  requiredTrimmedString,
  trimmedString,
} from "@/validation/sharedStringFieldSchemas"

const createUpdateCategoryFormSchema = z.object({
  name: requiredTrimmedString("Category name is required"),
  parentCategoryId: z.string().uuid().nullable(),
  color: trimmedString().nullable(),
})

export type CreateUpdateCategoryFormValues = z.input<
  typeof createUpdateCategoryFormSchema
>

export const useCreateUpdateCategoryForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createUpdateCategoryFormSchema
    ),
    initialValues: {
      name: "",
      color: null,
      parentCategoryId: null,
    },
  })
